import { render, staticRenderFns } from "./UpgradeSubscription.vue?vue&type=template&id=f87921d2&scoped=true"
import script from "./UpgradeSubscription.vue?vue&type=script&lang=js"
export * from "./UpgradeSubscription.vue?vue&type=script&lang=js"
import style0 from "./UpgradeSubscription.vue?vue&type=style&index=0&id=f87921d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87921d2",
  null
  
)

export default component.exports